import { captureStack1fzi4aczwc4hg as captureStack } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  commonAsUtf8ToByteArray20rkxdpc9aw5b as commonAsUtf8ToByteArray,
  commonToUtf8Stringyih6e1qg1yoo as commonToUtf8String,
} from './internal/-Utf8.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EOFExceptionClass;
function EOFException() {
  if (EOFExceptionClass === VOID) {
    class $ extends IOException() {
      constructor(message) {
        return new.target.new_okio_EOFException_6rq0ae_k$(message);
      }
      static new_okio_EOFException_6rq0ae_k$(message) {
        var $this = this.new_okio_IOException_86nzr8_k$(message);
        captureStack($this, $this.$throwableCtor_3);
        return $this;
      }
      static new_okio_EOFException_x4jje7_k$() {
        return this.new_okio_EOFException_6rq0ae_k$(null);
      }
    }
    initMetadataForClass($, 'EOFException', $.new_okio_EOFException_x4jje7_k$);
    EOFExceptionClass = $;
  }
  return EOFExceptionClass;
}
var IOExceptionClass;
function IOException() {
  if (IOExceptionClass === VOID) {
    class $ extends Exception() {
      constructor(message, cause) {
        return new.target.new_okio_IOException_k8occ2_k$(message, cause);
      }
      static new_okio_IOException_k8occ2_k$(message, cause) {
        var $this = this.new_kotlin_Exception_9qyiel_k$(message, cause);
        captureStack($this, $this.$throwableCtor_2);
        return $this;
      }
      static new_okio_IOException_86nzr8_k$(message) {
        return this.new_okio_IOException_k8occ2_k$(message, null);
      }
      static new_okio_IOException_6ep35h_k$() {
        return this.new_okio_IOException_k8occ2_k$(null, null);
      }
    }
    initMetadataForClass($, 'IOException', $.new_okio_IOException_6ep35h_k$);
    IOExceptionClass = $;
  }
  return IOExceptionClass;
}
function asUtf8ToByteArray(_this__u8e3s4) {
  return commonAsUtf8ToByteArray(_this__u8e3s4);
}
var ArrayIndexOutOfBoundsExceptionClass;
function ArrayIndexOutOfBoundsException() {
  if (ArrayIndexOutOfBoundsExceptionClass === VOID) {
    class $ extends IndexOutOfBoundsException() {
      constructor(message) {
        return new.target.new_okio_ArrayIndexOutOfBoundsException_bmu1rv_k$(message);
      }
      static new_okio_ArrayIndexOutOfBoundsException_bmu1rv_k$(message) {
        var $this = this.new_kotlin_IndexOutOfBoundsException_ddr8db_k$(message);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'ArrayIndexOutOfBoundsException');
    ArrayIndexOutOfBoundsExceptionClass = $;
  }
  return ArrayIndexOutOfBoundsExceptionClass;
}
function toUtf8String(_this__u8e3s4) {
  return commonToUtf8String(_this__u8e3s4);
}
//region block: exports
export {
  ArrayIndexOutOfBoundsException as ArrayIndexOutOfBoundsException3rm3ooo7dx3e8,
  EOFException as EOFException34hypof9gkxss,
  IOException as IOException3fje1ukjwthwb,
  asUtf8ToByteArray as asUtf8ToByteArray29u89fcaeh9ki,
  toUtf8String as toUtf8Stringtpd5urkuirog,
};
//endregion

//# sourceMappingURL=NonJvmPlatform.mjs.map
